import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useReactAnalytics } from "@soluto-private/eventualize-react";

interface GuideHomeConfirmationProps {
    callSid?: string;
    extraData?: Record<string, unknown>;
    isOpen: boolean;
    onSubmit: () => void;
    onClose: () => void;
}

function buttonCssVarOverrides() {
    return () => {
        return {
            root: {
                "--button-bg": "var(--mantine-color-primary-6)",
                "--button-hover": "var(--mantine-color-primary-7)",
            },
        };
    };
}
export function GuideHomeConfirmation({ callSid, extraData, isOpen, onClose, onSubmit }: GuideHomeConfirmationProps) {
    const { dispatcher } = useReactAnalytics();

    const enhancedDispatcher = callSid ? dispatcher.withIdentities({ CallSid: callSid }) : dispatcher;

    const handleSubmit = () => {
        void enhancedDispatcher.dispatchBusinessEvent(`Click_Guide_ConfirmRestartGuide`, {
            button: "ConfirmRestartGuide",
            ...extraData,
        });
        onSubmit();
    };

    const handleClose = () => {
        void enhancedDispatcher.dispatchBusinessEvent(`Click_Guide_CancelRestartGuide`, {
            button: "CancelRestartGuide",
            ...extraData,
        });
        onClose();
    };

    return (
        <Modal.Root opened={isOpen} onClose={handleClose} zIndex="var(--mantine-priority-highest)" centered>
            <Modal.Content>
                <Modal.Header styles={{ header: { alignItems: "unset" } }}>
                    <Modal.Title fw="bold">Return home?</Modal.Title>
                    <Modal.CloseButton onClick={handleClose} />
                </Modal.Header>
                <Modal.Body>
                    <Stack gap="1.25rem">
                        <Text size="sm">This action will reset progress on the current flow.</Text>
                        <Group justify="flex-end">
                            <Button
                                bg="transparent"
                                color="dark.1"
                                data-testid="cancel-restart-button"
                                onClick={handleClose}
                                size="md"
                                td="underline"
                                variant="subtle"
                            >
                                No
                            </Button>
                            <Button
                                size="md"
                                onClick={handleSubmit}
                                data-testid="confirm-restart-button"
                                variant="filled"
                                vars={buttonCssVarOverrides()}
                            >
                                Yes
                            </Button>
                        </Group>
                    </Stack>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
}
